<template>
    <div v-if="isShow" class="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50"
        @click.self="closePopup()">
        <div class="rounded-2xl shadow-2xl w-[95%] md:w-[50%] h-[90vh] md:h-auto md:max-h-[80%] overflow-hidden bg-white/95 backdrop-blur-md border border-white/20 flex flex-col"
            :class="{ 'animate-popupFadeIn': isVisible, 'animate-popupFadeOut': !isVisible }">
            <!-- Popup content -->
            <div class="relative w-full bg-brand p-4 shrink-0" style="background-color: var(--color-brand);">
                <h2 class="text-center text-yellow-500 font-bold text-[16px] tracking-wide">
                    Danh sách cửa hàng
                </h2>
                <button @click="closePopup()"
                    class="absolute right-4 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/10 hover:bg-red-500 hover:text-white flex items-center justify-center text-white/90 transition-colors shadow-sm">
                    <font-awesome-icon :icon="['fas', 'xmark']" />
                </button>
            </div>
            <div class="p-5 flex flex-col flex-1 min-h-0">
                <div class="relative mb-4 shrink-0">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                        <font-awesome-icon :icon="['fas', 'search']" />
                    </div>
                    <input type="text"
                        class="h-[44px] pl-10 pr-4 w-full border border-gray-200 bg-gray-50 rounded-xl focus:border-brand focus:ring-2 focus:ring-brand/20 focus:bg-white focus:outline-none text-[14px] text-gray-800 transition-all shadow-inner hover:bg-gray-100"
                        placeholder="Tìm kiếm cửa hàng..." v-model="fullbranchaddress">
                </div>

                <div v-if="isloading" class="flex justify-center flex-col items-center py-8">
                    <svg class="size-6 text-brand animate-spin mb-2" viewBox="0 0 24 24">
                        <font-awesome-icon :icon="['fas', 'spinner']" />
                    </svg>
                    <span class="text-sm font-medium text-gray-500">Đang tìm kiếm...</span>
                </div>

                <div v-else class="flex-1 overflow-y-auto border border-gray-200 rounded-xl shadow-sm bg-white min-h-[150px] no-scrollbar">
                    <template v-if="fullbranchaddress !== ''">
                        <div v-if="filteredAddresses.length === 0" class="p-8 text-gray-400 text-center text-sm italic">
                            Không tìm thấy dữ liệu phù hợp
                        </div>
                        <ul v-else class="divide-y divide-gray-100">
                            <li v-for="(address, index) in filteredAddresses" :key="index"
                                class="px-4 py-3 hover:bg-brand/5 cursor-pointer transition-colors text-gray-700 font-medium hover:text-brand text-sm"
                                @click="updateAddress(address)">
                                {{ address.shortaddress }}
                            </li>
                        </ul>
                    </template>
                    <template v-else>
                        <ul class="divide-y divide-gray-100">
                            <li v-for="(address, index) in listAddress" :key="index"
                                class="px-4 py-3 hover:bg-brand/5 cursor-pointer transition-colors text-gray-700 font-medium hover:text-brand text-sm"
                                @click="updateAddress(address)">
                                {{ address.shortaddress }}
                            </li>
                        </ul>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const API_URL = process.env.VUE_APP_API_URL;

export default {
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isVisible: true,
            listAddress: [], // Danh sách tất cả địa chỉ
            filteredAddresses: [], // Danh sách địa chỉ sau khi tìm kiếm
            fullbranchaddress: '', // Input tìm kiếm
            code: '',
            isloading: false,
            selectedAddress: null
        };
    },
    watch: {
        fullbranchaddress(newValue) {
            clearTimeout(this.searchTimeout);

            if (newValue) {
                this.isloading = true;
                this.searchTimeout = setTimeout(() => {
                    this.searchStores(newValue);
                }, 2000);
            } else {
                this.filteredAddresses = [];
                this.isloading = false; // <-- QUAN TRỌNG: tắt loading khi input rỗng
            }
        }
    },
    mounted() {
        const userStores = this.$app.userInfo?.stores;
        if (userStores && userStores.length > 0) {
            // Chỉ hiển thị các cửa hàng được gán cho user
            this.listAddress = userStores;
        }
        // Nếu user chưa được gán cửa hàng nào → không hiển thị gì
    },
    methods: {
        closePopup() {
            this.isVisible = false;
            setTimeout(() => {
                this.$emit('closed');
            }, 200);
        },
        updateAddress(address) {
            this.filteredAddresses = [];
            this.$emit('updateAddress', address);
        },
        async fetchStores() {
            this.isloading = true;
            try {
                const response = await this.$axios.get(`${API_URL}/stores/getall`);
                if (response.data) {
                    this.listAddress = response.data
                }
            } catch (error) {
                console.error("Lỗi khi lấy danh sách cửa hàng:", error);
            } finally {
                this.isloading = false;
            }
        },
        // async searchStores(query) {
        //     this.isloading = true;
        //     try {
        //         const response = await this.$axios.get(`${API_URL}/stores/search?q=${query}`, {
        //             headers: {
        //                 'Content-Type': 'application/json',
        //                 'X-Authorization': `Bearer ${this.$app.token}`,
        //             },
        //         });
        //         this.filteredAddresses = response.data;
        //         this.isloading = false
        //     } catch (error) {
        //         console.error("Lỗi tìm kiếm cửa hàng:", error);
        //     } finally {
        //         this.isloading = false;
        //     }
        // }

        async searchStores(query) {
            this.isloading = true;
            try {
                if (!query) {
                    this.filteredAddresses = this.listAddress;
                    return;
                }
                const q = query.toLowerCase();
                this.filteredAddresses = this.listAddress.filter(item => {
                    return (
                        (item.shortaddress && item.shortaddress.toLowerCase().includes(q)) ||
                        (item.fulladdress && item.fulladdress.toLowerCase().includes(q))
                    );
                });
            } catch (error) {
                console.error("Lỗi tìm kiếm cửa hàng:", error);
            } finally {
                this.isloading = false;
            }
        }

    }
};
</script>

<style scoped>
.no-scrollbar::-webkit-scrollbar {
    display: none;
}

.no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

@keyframes popupFadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes popupFadeOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(10px);
    }
}

.animate-popupFadeIn {
    animation: popupFadeIn 0.5s forwards;
}

.animate-popupFadeOut {
    animation: popupFadeOut 0.5s forwards;
}
</style>
